import { useState } from 'react'
import { RefreshCw, Eye, CheckCircle2, AlertCircle, Loader2, Zap } from 'lucide-react'
import { kassaAPI } from '@/lib/api'
import { Button } from '@/components/ui/button'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

const renderSummary = (label, s) => {
  if (!s) return null
  const parts = []
  if ('new' in s) parts.push(`+${s.new} nieuw`)
  if ('inserted' in s) parts.push(`+${s.inserted} nieuw`)
  if ('updated' in s) parts.push(`${s.updated} bijgewerkt`)
  if ('would-insert' in s) parts.push(`→ ${s['would-insert']} zouden worden toegevoegd`)
  if ('would-update' in s) parts.push(`→ ${s['would-update']} zouden worden bijgewerkt`)
  if ('unchanged' in s) parts.push(`${s.unchanged} ongewijzigd`)
  if ('skip' in s) parts.push(`${s.skip} overgeslagen`)
  return (
    <div className="text-xs mt-1">
      <span className="font-medium">{label}:</span> {parts.length ? parts.join(' · ') : 'geen wijzigingen'}
    </div>
  )
}

export default function KassaSyncButton() {
  const [running, setRunning] = useState(null)
  const [result, setResult] = useState(null)

  const run = async (kind, dryRun) => {
    setRunning(kind)
    setResult(null)
    try {
      let res
      if (kind === 'full') res = await kassaAPI.fullSync(dryRun)
      else if (kind === 'mapping') res = await kassaAPI.rebuildMapping(dryRun)
      else res = await kassaAPI.syncClan(dryRun)
      setResult({ ok: true, kind, dryRun, data: res.data })
    } catch (err) {
      setResult({ ok: false, kind, error: err.response?.data?.error || err.message })
    } finally {
      setRunning(null)
    }
  }

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        <Button variant="default" onClick={() => run('full', false)} disabled={running !== null}>
          {running === 'full' ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Zap className="h-4 w-4 mr-2" />}
          Volledige sync (kassa → lanserver)
        </Button>
        <Button variant="outline" onClick={() => run('full', true)} disabled={running !== null}>
          {running === 'full' ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Eye className="h-4 w-4 mr-2" />}
          Dry-run
        </Button>
        <Button variant="ghost" size="sm" onClick={() => run('mapping', false)} disabled={running !== null}>
          {running === 'mapping' ? <Loader2 className="h-3.5 w-3.5 mr-2 animate-spin" /> : <RefreshCw className="h-3.5 w-3.5 mr-2" />}
          Alleen mapping
        </Button>
      </div>

      {result && (
        <Alert variant={result.ok ? 'default' : 'destructive'}>
          {result.ok ? <CheckCircle2 className="h-4 w-4" /> : <AlertCircle className="h-4 w-4" />}
          <AlertTitle>
            {result.ok
              ? (result.dryRun ? 'Dry-run resultaat' : 'Sync klaar')
              : 'Sync mislukt'}
          </AlertTitle>
          <AlertDescription>
            {result.ok ? (
              <>
                {result.data?.clanMembers && renderSummary('clan_members', result.data.clanMembers.summary)}
                {result.data?.mapping && renderSummary('mapping', result.data.mapping.summary)}
                {result.data?.summary && !result.data?.clanMembers && renderSummary(result.kind === 'mapping' ? 'mapping' : 'clan_members', result.data.summary)}
                {result.data?.totalInKassa != null && (
                  <div className="text-[10px] text-muted-foreground mt-1">
                    {result.data.totalInKassa} RFID-gebruikers in kassa · {result.data.totalInClanMembers} in clan_members
                  </div>
                )}
              </>
            ) : (
              <span>{result.error}</span>
            )}
          </AlertDescription>
        </Alert>
      )}
    </div>
  )
}
